import { IAdHocGroupProject, IAdHocProject, IExportGroupProject, IGroupProject, IHatchetAiCompanyProjectOcr, IProject, IProjecToPost } from "../../models/applicationState";
import { AnyAction } from "../actions/actionCreators";
import { ActionTypes } from "../actions/actionTypes";

export const reducer = (state: IAdHocGroupProject = null, action: AnyAction): IAdHocGroupProject => {
    switch(action.type) {
        case ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT: {
            let grp = action.payload.adHocProjectModels;
            let groupProject: IAdHocProject[] = [];
            grp.forEach(g => {
                const p = JSON.parse(g.project);
                g.project = p;
                groupProject.push(JSON.parse(JSON.stringify(g)));                
            });
            return { 
                ...state,
                adhocGroupProjects: groupProject,
                adHocProjectProjectResults: action.payload.adHocProjectModels
            };
            break;
        }
        // case ActionTypes.SET_GENERATE_MODEL_GROUP: {
        //     return {
        //         ...state, 
        //         generateModelGroup: action.payload
        //     }
        // }
        case ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT: {
            const proj = action.payload;
            const p = JSON.parse(proj.project);
            proj.project = p;
            const adHocProject = JSON.parse(JSON.stringify(proj));
        
            // Find the index of the existing project
            const index = state.adhocGroupProjects.findIndex(r => r.project.id === adHocProject.project.id);
        
            // Create a copy of the array
            let adhocGroupProjects = [...state.adhocGroupProjects];
        
            if (index !== -1) {
                // Replace the project at the same position
                adhocGroupProjects[index] = adHocProject;
            } else {
                // If the project doesn't exist, add it to the end
                adhocGroupProjects.push(adHocProject);
            }

            let adHocProjectProjectResults = [...state.adHocProjectProjectResults];
            const projResultIndex = adHocProjectProjectResults.findIndex(r => r.projectName === proj.projectName);
            if (projResultIndex !== -1) {
                adHocProjectProjectResults[projResultIndex] = adHocProject;
            } else {
                adHocProjectProjectResults.push(adHocProject);
            }            
        
            return {
                ...state,
                adhocGroupProjects,
                adHocProjectProjectResults,
                refreshKey: generateGuid() // Generate a new key to trigger refresh
            };
        }
        // case ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT: {
        //     const proj = action.payload;
        //     const p = JSON.parse(proj.project);
        //     proj.project = p;
        //     const adHocProject = JSON.parse(JSON.stringify(proj));
        //     let adhocGroupProjects = state.adhocGroupProjects.filter(r => r.project.id !== adHocProject.project.id);
        //     adhocGroupProjects.push(adHocProject);
        //     return { 
        //         ...state,
        //         adhocGroupProjects: adhocGroupProjects,
        //     }
        // }
        case ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT_REFRESH: {
            return {
                ...state, 
                refreshKey: action.payload
            };
        }
        case ActionTypes.AD_HOC_OCR_V3_TOGGLE_PROJECT_TO_POST: {
            let projectToPost: IProjecToPost = action.payload;
            let { projectToPosts } = state;
            if (!projectToPosts) {
                projectToPosts = [];
            }
            projectToPosts = projectToPosts.filter(p => p.projectId !== projectToPost.projectId); 
            if (projectToPost.selected) {
                projectToPosts.push(projectToPost);
            }
            return {
                ...state, 
                projectToPosts: projectToPosts                
            }
        }
        case ActionTypes.AD_HOC_OCR_V3_REMOVE_GROUP_PROJECT_DOCUMENT: {
            let exportGroupProject: IExportGroupProject = action.payload;
            if (exportGroupProject) {
                let adhocGroupProjects = JSON.parse(JSON.stringify([...state.adhocGroupProjects]));                
                let adHocProjectProjectResults = JSON.parse(JSON.stringify([...state.adHocProjectProjectResults]));
                exportGroupProject.exportDocuments.forEach(doc => { 
                    let index = adhocGroupProjects.findIndex(r => r.project.id === doc.requestId);
                    if (index !== -1) {
                        let adHocProject = adhocGroupProjects[index];
                        adHocProject.status = 'Posted';                        
                    }
                    index = adHocProjectProjectResults.findIndex(r => r.projectName === doc.requestId);
                    if (index !== -1) {
                        let adHocProject = adHocProjectProjectResults[index];
                        adHocProject.status = 'Posted';
                    }
                    // adhocGroupProjects = adhocGroupProjects.filter(r => r.project.id !== doc.requestId);
                    // adHocProjectProjectResults = adHocProjectProjectResults.filter(r => r.projectName !== doc.requestId);
                });                
                return {
                    ...state, 
                    adhocGroupProjects: [...adhocGroupProjects],
                    adHocProjectProjectResults: [...adHocProjectProjectResults], 
                    projectToPosts: []
                }
            }
            else {
                return state;
            }                 
        }
        default: {
            return state;
        }
    }
}

function generateGuid(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
        const random = (Math.random() * 16) | 0; // Generate a random number between 0 and 15
        const value = char === "x" ? random : (random & 0x3) | 0x8; // Use 0x8 for the "y" position
        return value.toString(16); // Convert to hexadecimal
    });
}